import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import axios from 'axios';
import '@/App.css';
import { Toaster } from '@/components/ui/sonner';
import Auth from '@/pages/Auth';
import Dashboard from '@/pages/Dashboard';
import Simulator from '@/pages/Simulator';
import IngredientLibrary from '@/pages/IngredientLibrary';
import FormulaLibrary from '@/pages/FormulaLibrary';
import Troubleshooting from '@/pages/Troubleshooting';
import Layout from '@/components/Layout';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const AuthContext = React.createContext();

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('cosmolab_token');
    const savedUser = localStorage.getItem('cosmolab_user');
    
    if (token && savedUser) {
      setUser(JSON.parse(savedUser));
      axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    }
    setLoading(false);
  }, []);

  const login = (token, userData) => {
    localStorage.setItem('cosmolab_token', token);
    localStorage.setItem('cosmolab_user', JSON.stringify(userData));
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    setUser(userData);
  };

  const logout = () => {
    localStorage.removeItem('cosmolab_token');
    localStorage.removeItem('cosmolab_user');
    delete axios.defaults.headers.common['Authorization'];
    setUser(null);
  };

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#FBFBF9]">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-[#2F4840]"></div>
      </div>
    );
  }

  return (
    <AuthContext.Provider value={{ user, login, logout }}>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route
              path="/auth"
              element={!user ? <Auth /> : <Navigate to="/" />}
            />
            <Route
              path="/"
              element={user ? <Layout><Dashboard /></Layout> : <Navigate to="/auth" />}
            />
            <Route
              path="/simulator"
              element={user ? <Layout><Simulator /></Layout> : <Navigate to="/auth" />}
            />
            <Route
              path="/ingredients"
              element={user ? <Layout><IngredientLibrary /></Layout> : <Navigate to="/auth" />}
            />
            <Route
              path="/formulas"
              element={user ? <Layout><FormulaLibrary /></Layout> : <Navigate to="/auth" />}
            />
            <Route
              path="/troubleshooting"
              element={user ? <Layout><Troubleshooting /></Layout> : <Navigate to="/auth" />}
            />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" />
      </div>
    </AuthContext.Provider>
  );
}

export default App;
